import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, ref, computed, watch } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useOpportunitiesStore } from '@/store/opportunities';
import { useOpportunityStatusesStore } from '@/store/opportunityStatuses';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/opportunities/opportunities.config';
import { useLayoutField } from '@/composables/useLayoutField';
import { CARD_FIELDS, DEFAULT_CARD_ORDER } from '@/components/modules/sales/sales.config';
import { useDisplay } from 'vuetify';

import Kanban from '@/components/views/KanbanView.vue';
import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

const moduleName = 'Opportunities';

export default /*@__PURE__*/_defineComponent({
  __name: 'Opportunities',
  props: {
    clientId: {},
    client: {}
  },
  setup(__props: any) {

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const preferencesStore = usePreferencesStore();

const opportunitiesStore = useOpportunitiesStore();
const opportunityStatusesStore = useOpportunityStatusesStore();

const currentView = useLayoutField(moduleName, 'currentView');
const filters = ref({}); // ← Tus filtros actuales reactivos (ajusta según tu app)

const props = __props;

const { clientId } = props;

const buildParams = (params: any) => {
  // Solo agrega el filtro si clientId está definido y es válido
  if (clientId !== undefined && clientId !== null) {
    return {
      ...params,
      'filter[subject_id]': clientId,
      'filter[subject]': "clients",
    };
  }
  return params;
};

// Composable que centraliza el fetch:
const {
  create,
  update,
  remove,
  exportCsv,
  refresh // ← Asegúrate de exponer una función "refresh" en tu composable
} = useModuleLayoutFetcher(
  moduleName,
  (params) => currentView.value == 'kanban'
    ? opportunityStatusesStore.fetchOpportunityStatuses(buildParams(params))
    : opportunitiesStore.fetchOpportunities(buildParams(params)),
  {
    create: opportunitiesStore.createOpportunity,
    update: (data) => opportunitiesStore.updateOpportunity(data.id, data),
    remove: opportunitiesStore.deleteOpportunity,
    exportCsv: opportunitiesStore.exportCSV
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find((header:any) => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

// Centraliza los datos
const data = computed(() =>
  currentView.value == 'kanban'
    ? opportunityStatusesStore.opportunityStatuses
    : opportunitiesStore.opportunities
);

// ⬇️ Reacciona a cambios en la vista o en los filtros. Siempre usa la función "refresh" del composable
watch(
  [() => currentView.value, filters],
  ([view, filterParams]) => {
    refresh(filterParams); // Siempre respeta los filtros/params activos
  },
  { immediate: true }
);

// TIP: Si tienes filtros en otro store o variable, ponlos aquí.

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(ViewsContainer, {
        moduleName: moduleName,
        kanbanViewComponent: Kanban,
        listViewComponent: Table,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/leads/leads.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        exportCsv: _unref(exportCsv),
        onRecordUpdate: _unref(opportunitiesStore).updateOpportunity,
        onDelete: _unref(remove),
        show_toolbar: true,
        show_pagination: false,
        title: {singular:'Oportunidad', plural:'Oportunidades'},
        key: moduleName,
        client: _ctx.client,
        clientId: _unref(clientId)
      }, null, 8, ["data", "onCreate", "onUpdate", "exportCsv", "onRecordUpdate", "onDelete", "client", "clientId"]))
    ]),
    _: 1
  }))
}
}

})